import React from "react"
import {
  Box,
  Container,
  Typography,
  makeStyles
} from '@material-ui/core';

const styles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(2)
  },
  image: {
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
}));


const PageNotFound = () => {
    const classes = styles();
    return(
      <div className={classes.root}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="md">
        <Box textAlign="center">
            <img
              alt="Under development"
              className={classes.image}
              src="images/not-found.svg"
            />
          </Box>
          <Typography
            align="center"
            color="textPrimary"
            variant="h3"
          >
            404: The page you are looking for isn’t here
          </Typography>
          <Typography
            align="center"
            color="textPrimary"
            variant="subtitle2"
          >
            You either tried some shady route or you're not authorised to visit that page.
            You can either login or go back to the homepage
          </Typography>  
        </Container>
      </Box>
      </div>
    )
}
export default PageNotFound